import { TopNavLayout } from "@cjdev-internal/visual-stack-x/TopNavLayout";

export const withDialog = (Component, props) => {
  return <TopNavLayout {...props}>{Component}</TopNavLayout>;
};
